// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4468":"af2effb9","4817":"e790e880","5744":"33b69ede","8105":"0b8f916d","8364":"af2effb9","9246":"af2effb9"}[chunkId] + ".chunk.css";
};